import React from 'react';
import { faCircleDollar } from '@fortawesome/pro-solid-svg-icons/faCircleDollar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CircleDollarSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCircleDollar} {...props} />;
}
